var React = require('react');

function MainGradient (props) {
    return React.createElement("svg",props,React.createElement("defs",null,React.createElement("linearGradient",{"x1":"0%","y1":"0%","x2":"100%","y2":"100%","gradientUnits":"userSpaceOnUse","id":"mainGradient"},[React.createElement("stop",{"offset":"0","stopColor":"#e20018","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#ff71e4","key":1})])));
}

MainGradient.defaultProps = {"viewBox":"0 0 512 335.86"};

module.exports = MainGradient;

MainGradient.default = MainGradient;
